import { View } from '../base/View';
import { ensureElement } from '../../utils/utils';
export class CardBasketView extends View {
    constructor(container, actions) {
        super(container);
        this._label = ensureElement('.basket__item-index', container);
        this._title = ensureElement('.card__title', container);
        this._price = ensureElement('.card__price', container);
        this._button = ensureElement('.card__button', container);
        this._button.addEventListener('click', () => {
            var _a;
            (_a = actions === null || actions === void 0 ? void 0 : actions.onClick) === null || _a === void 0 ? void 0 : _a.call(actions);
        });
    }
    set label(value) {
        this.setText(this._label, value);
    }
    set title(value) {
        this.setText(this._title, value);
    }
    set price(value) {
        this.setText(this._price, value);
    }
}
